export default __webpack_public_path__ + "static/media/UseCase1-Alerts-EmptyDrawerBKGD.c46188ec.png";